import React from 'react';
import MainPage from "./index";

const SixDPage = (props) =>  <MainPage type={6} {...props}/>;
export default SixDPage;
